export default {
  'site-name': 'Gifta Blog',
  'site-title': 'Gifta Blog',
  'gifta-site-title': 'Gifta Website',
  'gifta-site-link': 'https://www.gifta.com/',
  'pixa-site-title': 'Pixartprinting Website',
  'pixa-site-link': 'https://www.pixartprinting.co.uk/',
  'load-more-article': 'Read more articles',
  'next-slide': 'Next',
  'prev-slide': 'Previous',
  'next-pagination': 'Next',
  'prev-pagination': 'Previous',
  'next-article': 'Next article',
  'related-articles': 'Related articles',
  'back-to-top': 'Back to top',
  search: 'Search',
  'erase-research': 'Clear search',
  close: 'Close',
  'newsletter-title': 'Newsletter',
  'newsletter-text':
    'Sii tra i primi ad essere aggiornato <br> sulle novità di Gifta blog.',
  'newsletter-cta': 'Register',
}
